module.exports = __webpack_public_path__ + "static/media/9@960w.6cc7f036.jpg";